import { SourceDetails } from 'features/layout/types';
import { RemoteAudio } from 'features/streaming/components/media/remote-stream/RemoteAudio';
import { memo } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectFeedIdByUser, selectRemoteStreams } from 'features/streaming/streamingSlice';

type RemoteAudioWrapperProps = {
  source: SourceDetails;
};

const RemoteAudioWrapper = memo(({ source }: RemoteAudioWrapperProps) => {
  const lookupFeedId = useAppSelector((state) => selectFeedIdByUser(state, source.userId));
  const feedId = source.feedId || lookupFeedId;

  const streams = useAppSelector((state) =>
    feedId ? selectRemoteStreams(state, source.userId, feedId) : undefined
  );

  const audioStream = streams?.find((s) => s.kind === 'audio');

  if (!feedId || !audioStream?.mid) {
    return null;
  }

  return <RemoteAudio mid={audioStream.mid} />;
});

export default RemoteAudioWrapper;
